import { render, staticRenderFns } from "./TDSError.vue?vue&type=template&id=7aa632de&scoped=true"
import script from "./TDSError.vue?vue&type=script&lang=ts"
export * from "./TDSError.vue?vue&type=script&lang=ts"
import style0 from "./TDSError.vue?vue&type=style&index=0&id=7aa632de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa632de",
  null
  
)

export default component.exports